var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBobSquares(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/logo-bob-squares"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primarytint",
    d: "M11.426 9.53v.632H7.632v6.323h6.324v-3.794h.632v4.426H7V9.53h4.426zm3.162 0v2.529h-2.53v-2.53h2.53zM17.118 7v5.059H15.22v-.633h1.265V7.632h-3.794v1.265h-.632V7h5.058zm-3.162 3.162H12.69v1.264h1.265v-1.264z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBobSquares);
export default __webpack_public_path__ + "static/media/logoBobSquares.1bd5d6413c0e402b9c226662f65f3eed.svg";
export { ForwardRef as ReactComponent };